import { fmeaTemplatesService } from './fmeaTemplates.service';

export const fmeaTemplatesConstants = {
  LIST_REQUEST: 'FMEA_TEMPLATES_LIST_REQUEST',
  LIST_SUCCESS: 'FMEA_TEMPLATES_LIST_SUCCESS',
  LIST_FAILURE: 'FMEA_TEMPLATES_LIST_FAILURE',
  CREATE_SUCCESS: 'FMEA_TEMPLATES_CREATE_SUCCESS',
  UPDATE_SUCCESS: 'FMEA_TEMPLATES_UPDATE_SUCCESS',
  DELETE_SUCCESS: 'FMEA_TEMPLATES_DELETE_SUCCESS',
};

export const listFmeaTemplates = scope => (dispatch) => {
  dispatch({ type: fmeaTemplatesConstants.LIST_REQUEST });
  return fmeaTemplatesService.listTemplates(scope).then(
    (data) => {
      dispatch({ type: fmeaTemplatesConstants.LIST_SUCCESS, data });
      return data;
    },
    (error) => {
      dispatch({ type: fmeaTemplatesConstants.LIST_FAILURE, error });
    }
  );
};
